export default __webpack_public_path__ + "static/media/green_tick.498eae12.svg";